const data = {
  id: 1,
  title: 'Listen and choose all the letter mentioned.',
  subTitle: 'Nghe và chọn tất cả các chữ cái được nhắc đến.',
  answers: [
    { answer: 'b', isCorrect: false },
    { answer: 'A', isCorrect: true },
    { answer: 'B', isCorrect: false },
    { answer: 'a', isCorrect: true },
    { answer: 'C', isCorrect: false },
    { answer: 'c', isCorrect: false },
  ],
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/8f4b4330-c9c0-48c7-92ab-b16f24b4fcfa.mp3',
};

export default data;
